export const initialValues: ISimpleFormInitialValues = {
  negotiated_price: false,
  price: '',
  grade: false,
};
